export const KEY_TOKEN = 'AccessToken';
export type Roles = 'admin' | 'agency' | 'client';
export const KEY_INFO_USER = 'InfoUser';
export const PERMISSIONS = 'Permissions';
export const DEFAULT_MONTH_FORMAT = 'MM-YYYY';
